module.exports = __webpack_public_path__ + "static/img/vip_group_title_bg.5b4819d3.png";